import { styled } from '@volkswagen-onehub/components-core';
import { useSelector } from 'react-redux';
import { OneFormState } from 'src/types';
import React from 'react';

interface InputWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
	notALayer?: boolean;
	paddingTop?: string;
	paddingBottom?: string;
	children?: React.ReactNode;
}

const StyledInputWrapper = styled.div<InputWrapperProps>`
	width: 100%;
	margin-bottom: 2px; // Fix para visualizar el border bottom del input
	padding-top: ${(p) => (p.paddingTop ? p.paddingTop : '44px')};
	padding-bottom: ${(p) => (p.paddingBottom ? p.paddingBottom : '0px')};

	@media all and (max-height: 624px) {
		padding-top: ${(p) => (p.paddingTop ? p.paddingTop : '24px')};
	}
	@media all and (min-width: 560px) {
		width: ${(p) => (p.notALayer ? 'var(--size-grid013)' : '303px')};
	}
	@media all and (min-width: 960px) {
		width: ${(p) => (p.notALayer ? 'var(--size-grid008)' : '320px')};
	}
	@media all and (min-width: 1280px) {
		width: ${(p) => (p.notALayer ? 'var(--size-grid006)' : '320px')};
	}
	@media all and (min-width: 1920px) {
		width: ${(p) => (p.notALayer ? 'var(--size-grid005)' : '320px')};
	}
	@media all and (min-width: 2560px) {
		width: ${(p) => (p.notALayer ? 'var(--size-grid004)' : '320px')};
	}

	/* Eliminar flechas del input type number */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	input[type='number'] {
		-moz-appearance: textfield;
	}
`;

const StyledInputGroupWrapper = styled.div<InputWrapperProps>`
	gap: 24px;
	display: flex;
	flex-direction: column;
	width: 100%;
	padding-top: ${(p) => (p.paddingTop ? p.paddingTop : '44px')};
	padding-bottom: ${(p) => (p.paddingBottom ? p.paddingBottom : '0px')};

	@media screen and (min-width: 960px) {
		display: flex;
		justify-content: space-between;
		flex-direction: row;
		flex-wrap: wrap;
		margin-top: 0;
	}

	& > div {
		padding-top: 0 !important; // Usamos gap de flex
	}
`;

export const InputWrapper: React.FC<InputWrapperProps> = ({ children, notALayer, ...props }) => {
	const { formInfo } = useSelector((state: OneFormState) => state);
	const effectiveNotALayer = notALayer ?? formInfo?.notALayer ?? false;

	return (
		<StyledInputWrapper {...props} notALayer={effectiveNotALayer}>
			{children}
		</StyledInputWrapper>
	);
};

export const InputGroupWrapper: React.FC<InputWrapperProps> = ({ children, notALayer, ...props }) => {
	const { formInfo } = useSelector((state: OneFormState) => state);
	const effectiveNotALayer = notALayer ?? formInfo?.notALayer ?? false;

	return (
		<StyledInputGroupWrapper {...props} notALayer={effectiveNotALayer}>
			{children}
		</StyledInputGroupWrapper>
	);
};
